import { isTelemetryServiceInitialized, logError, } from '@office-start/telemetry-service';
var shellRenderedPromise;
var shellRenderedPromiseResolve;
var shellRenderedPromiseReject;
var shellPromiseInitialized = false;
var isOfficeHomeReact = false;
function initializeShellRenderPromise() {
    if (isOfficeHomeReact) {
        // V2TODO: This means we are using V2 React Application instead of Angular application. Remove this check after we move to full React Application
        shellRenderedPromise = new Promise(function (resolve, reject) {
            shellRenderedPromiseResolve = resolve;
            shellRenderedPromiseReject = reject;
        });
    }
    else {
        // V2TODO: This means we are using Angular Application
        if (window.shellRenderedPromise) {
            shellRenderedPromise = window.shellRenderedPromise;
            shellRenderedPromiseResolve = window.shellRenderedPromiseResolve;
            shellRenderedPromiseReject = window.shellRenderedPromiseReject;
        }
        else {
            // V2TODO: This means there is no window.shellRenderedPromise while we are using Angular application, which is an error. Remove this check after we move to full React application
            var errorMessage = 'ShellRendered promise does not exist, unable to get shell status';
            if (isTelemetryServiceInitialized()) {
                logError({
                    eventName: 'Shell_Shim_Load',
                    errorType: 'Shell_Bootstrap_Error',
                    message: errorMessage,
                });
            }
            else {
                window.standaloneOteLogger.logBootError('Shell_Bootstrap_Error', errorMessage);
            }
        }
    }
    shellPromiseInitialized = true;
}
function checkPromiseInitialized() {
    if (!shellPromiseInitialized)
        initializeShellRenderPromise();
}
export function setUsingReactShellPromise() {
    isOfficeHomeReact = true;
}
export function getShellRenderedPromise() {
    checkPromiseInitialized();
    return shellRenderedPromise;
}
export function resolveShellRenderedPromise(value) {
    checkPromiseInitialized();
    shellRenderedPromiseResolve(value);
}
export function rejectShellRenderedPromise(reason) {
    checkPromiseInitialized();
    shellRenderedPromiseReject(reason);
}
//# sourceMappingURL=shellRenderedPromise.js.map